<template>
  <section class="hero deal has-background-primary-light has-no-background-print avoid-break-inside break-after" v-if="$options.filters.haspromotion(product, 'TravelDeal')">
    <div class="hero-body">
      <div class="container">
        <div class="columns is-centered">
          <div class="column is-7">
            <router-link
              class="is-block u-h100"
              @click.native="trackProduct"
              :to="{
                name: 'urlaub',
                params: {
                  slug: product.slug,
                  contact: product.contact.slug,
                },
              }"
            >
              <div class="deal-img-wrap is-relative">
                <h2 class="deal-headline title has-text-centered u-p1 is-size-5 is-size-4-tablet is-size-3-desktop">
                  <span class="is-uppercase is-inline-block">{{ $whitelabel.dealName ? $whitelabel.dealName : $t('general.travel-deal') }}</span>
                </h2>
                <div v-if="hasCountdown" class="deal-countdown has-text-weight-normal has-text-dark is-hidden-print">
                  <p class="has-text-centered is-size-6-tablet">
                    {{ $whitelabel.dealCountdownTitle ? $whitelabel.dealCountdownTitle : $t('product.deal-ends') }}
                  </p>
                  <CountdownTimer :endTime="dealTimer" class="has-text-centered deal-countdown__timer" />
                </div>

                <picture>
                  <!-- <source :srcset="`https://assets.urlaubsgutschein.kaufen/i/resize?width=550&quality=50&interlace=true&type=auto&file=${product.image}`" media="(max-width: 480px), (min-width: 769px) and (max-width: 1215px)" /> -->

                  <source :srcset="`https://assets.urlaubsgutschein.kaufen/i/crop?width=450&height=450&gravity=smart&quality=50&interlace=true&type=auto&file=${product.image}`" media="(max-width: 450px)" />
                  <source :srcset="`https://assets.urlaubsgutschein.kaufen/i/crop?width=750&height=450&gravity=smart&quality=50&interlace=true&type=auto&file=${product.image}`" media="(max-width: 768px)" />
                  <source :srcset="`https://assets.urlaubsgutschein.kaufen/i/crop?width=550&height=450&gravity=smart&quality=50&interlace=true&type=auto&file=${product.image}`" media="(max-width: 1215px)" />
                  <source :srcset="`https://assets.urlaubsgutschein.kaufen/i/crop?width=660&height=450&gravity=smart&quality=50&interlace=true&type=auto&file=${product.image}`" media="(max-width: 1407px)" />
                  <source :srcset="`https://assets.urlaubsgutschein.kaufen/i/crop?width=770&height=450&gravity=smart&quality=50&interlace=true&type=auto&file=${product.image}`" media="(min-width: 1408px)" />

                  <img fetchpriority="high" class="deal-img" :src="`https://assets.urlaubsgutschein.kaufen/i/crop?width=770&height=450&quality=50&gravity=smart&interlace=true&type=auto&file=${product.image}`" :alt="product.contact.name" />
                </picture>

                <!-- <Badge v-if="$options.filters.haspromotion(product, 'InsuranceIncluded')" :text="`Gutschein<br>Garantie`" :color="['rgba(253, 216, 53, 1)', 'rgba(249, 168, 37, 1)']" class="deal-badge" /> -->
                <!-- <Badge v-if="this.$whitelabel.short.toLowerCase() === 'greenstorm'" :text="`Geld-zurück<br>Garantie`" :color="['rgba(133, 176, 19, 1)', 'rgba(133, 176, 19, 1)']" class="deal-badge c-badge--greenstorm" /> -->
              </div>
            </router-link>
          </div>
          <div class="deal-content column is-5 is-4-widescreen is-3-fullhd is-flex is-flex-direction-column is-justify-content-space-evenly">
            <ReductionDisplay ref="reductionTag" v-if="$whitelabel.showReduction" :beforePrice="product.price.list" :afterPrice="product.price.total" size="is-large" />

            <p class="title card__title is-4">
              <span class="is-size-7 has-text-weight-normal is-family-sans-serif">{{ product.contact.city }}, {{ product.contact.state }}</span
              ><br />
              {{ product.contact.name }}<br /><StarDisplay :stars="product.contact.category" />
            </p>
            <p class="subtitle is-6 card-subtitle">{{ product.display }}</p>

            <strong>
              <span v-for="room in product.rooms" :key="room.name">{{ room.name }}</span>
              <br />
              <span v-for="board in product.boards" :key="board.short">{{ board.longName }}</span
              >, <MinMaxDisplay :min="product.nights.min" :max="product.nights.max" />{{ $t('general.nights') }}
            </strong>

            <div class=" is-size-6 mt-5 has-text-right">
              <p>{{ $t('general.instead-of') }} {{ product.persons.max === 2 ? product.price.list / 2 : product.price.list | amount }}</p>
              <p class="has-text-weight-bold">
                {{ product.price.prefix }}
                <span class="is-size-3">
                  {{ product.price.currency | currency }}
                  <span class="card-offer__price is-inline-block" ref="price">{{ product.price.display | amount }}</span>
                </span>
              </p>
            </div>

            <b-button
              tag="router-link"
              :to="{
                name: 'urlaub',
                params: {
                  slug: product.slug,
                  contact: product.contact.slug,
                },
              }"
              :type="this.$whitelabel.short.toLowerCase() === 'urlaubsguru' ? 'is-primary' : 'is-dark'"
              size="is-large"
              class="is-block mt-4 is-hidden-print"
              expanded
              @click.native="trackProduct"
            >
              {{ $whitelabel.dealButton ? $whitelabel.dealButton : $t('product.to-deal') }}
            </b-button>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
//import Badge from '@/components/Badge'
import ReductionDisplay from '@/components/ReductionDisplay'
import StarDisplay from '@/components/StarDisplay'
import MinMaxDisplay from '@/components/MinMaxDisplay'
import CountdownTimer from '@/components/CountdownTimer'
import promotion from '@/common/promotion'

export default {
  name: 'Deal',
  components: {
    //Badge,
    ReductionDisplay,
    StarDisplay,
    MinMaxDisplay,
    CountdownTimer,
  },
  props: {
    product: {
      type: Object,
    },
    hasCountdown: {
      type: Boolean,
      default: true,
    },
  },

  computed: {
    dealTimer: function() {
      const cdDate = promotion.getEndDateForPromotion('TravelDeal', this.product)
      if (cdDate) {
        return cdDate - new Date()
      }
      return null
    },
  },
  methods: {
    trackProduct() {
      this.$eventDispatcher.dispatch('offer_clicked', {
        product: this.product,
      })
    },
  },
}
</script>

<style lang="scss">
.deal {
  position: relative;
  left: 50%;
  right: 0;
  width: 100vw;
  transform: translateX(-50%);
  margin-top: 3rem;
  margin-bottom: 3rem;

  @media screen and (max-width: 768px) {
    .hero-body {
      padding-top: 0;
    }
  }
}

.deal-img {
  height: 100%;
  width: 100%;
  object-fit: cover;
  max-height: 450px;
}

.deal-badge {
  position: absolute;
  bottom: 2rem;
  left: 2.5rem;
}

.deal-headline,
.deal-countdown {
  position: absolute;
  background-color: rgba(255, 255, 255, 0.9);
  z-index: 1;
}

.deal-headline {
  top: 2rem;
  width: 100%;
}

.deal-countdown {
  bottom: 2rem;
  right: 0.5rem;
  padding: 1rem 1.5rem;
  transform-origin: right bottom;
  transform: scale(0.7);

  .countdown__column {
    flex-basis: auto; //fix for ie11
    padding-left: 0.35rem; //fix for ie11
    padding-right: 0.35rem; //fix for ie11
  }
}

.deal-countdown__timer {
  margin-top: -1rem;
}

@media screen and (min-width: 480px) {
  .deal-countdown {
    transform: scale(1);
  }
}

@media screen and (max-width: 768px) {
  .deal-img-wrap {
    position: relative;
    left: 50%;
    right: 0;
    width: 100vw;
    transform: translateX(-50%);
    display: block;
  }

  .deal-badge {
    left: 1rem;
  }

  .deal-img {
    aspect-ratio: 16 / 10;
  }
}

@media screen and (min-width: 769px) {
  .deal-countdown {
    bottom: 2rem;
    right: 2rem;
    padding: 1rem 1.5rem;
    transform: scale(1);
  }

  .deal-countdown__timer {
    margin-top: -1rem;
  }

  .deal-img-wrap {
    height: 100%;
  }
}

@media screen and (min-width: 769px) and (max-width: 900px) {
  .deal-countdown {
    transform: scale(0.8);
  }
}

@media print {
  .deal-img-wrap,
  .deal-img {
    height: 100% !important;
  }
}
</style>
